import React, {Fragment } from 'react';

import OrderModel from '../../../models/PickupOrder';

import { Radio, RadioGroup, FormControlLabel, Typography, Button } from '@material-ui/core';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { RadioButtonUnchecked, RadioButtonChecked }from '@material-ui/icons';

import TruckingCompanyContainer from  '../../pickupOrder/truckingCompany/TruckingCompanyContainer';
import NotifyTruckingCompanyContainer from '../../pickupOrder/notifyTruckingCompany/NotifyTruckingCompanyContainer';
import OrderButtonsContainer from './ordersButtons/OrderButtonsContainer';

import style from './ordersStyle.module.css';
import commonStyles from '../../common/common.module.css';

import TruckDriverContainer from '../../pickupOrder/truckDriver/TruckDriverContainer';
import DriverTruckInput from '../driver/DriverTruckInput';

const styles = (theme: Theme) =>

  createStyles({
    radioGroup: {
      justifyContent: 'space-between'
    },
    formControlLabel: {
      marginLeft: '1%',
      marginRight: '2%'
    },
    label: {
      color: 'var(--primaryblue)'
    },
    button: {
      minWidth: '110px',
      fontSize: '13px'
    }
  });

interface CommonOrderTruckingInfoWrapperProps {
  classes: any;
  type?: string;
  selectedDeliveryCompanyID: number | undefined;
  setDeliveryCompanyID: (deliveryCompanyID: number) => void;
  setDriverID: Function;
  selectedDriverID: number | undefined;
  changeDriverDetails: Function;
  changedDriver: Function;
  initialDriverID: number | undefined;
  showDetails: boolean;
  hideTruckerInfo: () => void;
  resetPickupTime: () => void;
  changedDeliveryCompany: (newDeliveryCompanyID: number) => void;
  initialDeliveryCompanyID: number | undefined;
  order: OrderModel;
  sendOrder: string;
  handleChangeSendOrder: (event: any) => void;
  submitPickupOrder: () => void;
  handleClick: Function;
  maskOn: Function;
};

const commonOrderTruckingInfoWrapper = (props: CommonOrderTruckingInfoWrapperProps) => {

  return (
    <Fragment>
      <div className={ commonStyles.wrapper }>
        <h1 className={ commonStyles.header }>Trucking Information</h1>
      
        <div className={ style.horizontalLine }></div>

        <RadioGroup
          name="sendOrder"
          value={ props.sendOrder }
          row={ true }
          onChange={ props.handleChangeSendOrder }
          className={ props.classes.radioGroup }
        >
          <FormControlLabel 
            value="truckingCompany" 
            className={ props.classes.formControlLabel }
            control={
              < Radio 
                icon={ <RadioButtonUnchecked color='primary' /> }
                checkedIcon={ <RadioButtonChecked color='primary' /> }
              /> 
            } 
            label={<Typography className={ props.classes.label }> Send order to trucking company or warehouse operator</Typography>}
          />

          <FormControlLabel 
            value="driver" 
            className={ props.classes.formControlLabel }
            control={
              < Radio 
                icon={ <RadioButtonUnchecked color='primary' /> }
                checkedIcon={ <RadioButtonChecked color='primary' /> }
              /> 
            } 

            label={<Typography className={ props.classes.label }> Send order directly to truck driver</Typography>}
          />

        </RadioGroup>

        { props.sendOrder === 'truckingCompany' && 

          <div className={style.notifyAndTruckWrapper }>

            <div className={ style.truckingWrapper } >

              <TruckingCompanyContainer 
                selectedDeliveryCompanyID={ props.showDetails ? props.selectedDeliveryCompanyID : props.order.id_delivery_company || undefined }
                setDeliveryCompanyID={ props.setDeliveryCompanyID }
                showDetails={ props.showDetails }
                hideTruckerInfo={ props.hideTruckerInfo }
                resetPickupTime={ props.resetPickupTime }
                changedDeliveryCompany={ props.changedDeliveryCompany }
                initialDeliveryCompanyID={ props.initialDeliveryCompanyID }
                poDeliveryCompanyID={ props.order.id_delivery_company }
                allowedToChangeTruckingCompany={ props.order.allowed_ops.update_dispatch_driver_details }
              />

              <Button className={ props.classes.button } onClick={ props.submitPickupOrder } color="primary" variant="contained" >Update</Button>

            </div>

            <div className={style.notifyAndBtnWrapper}>

              {props.type !== 'go' && (
                <NotifyTruckingCompanyContainer
                  pickupOrder={ props.order }
                  notifyWho={ "truckingCompany" }
                  selectedDeliveryCompanyID={ props.showDetails ? props.selectedDeliveryCompanyID : props.order.id_delivery_company || undefined }
                />
              )}

              <OrderButtonsContainer
                order={ props.order }
              />

            </div>

          </div>
        }
        { props.sendOrder === 'driver' && 

          <div className={style.notifyAndTruckWrapper }>

            <div className={ style.driverWrapper } >

              <TruckDriverContainer 
                selectedDriverID={ props.showDetails ? props.selectedDriverID : props.order.id_driver || undefined }
                setDriverID={ props.setDriverID }
                showDetails={ props.showDetails }
                hideTruckerInfo={ props.hideTruckerInfo }
                resetPickupTime={ props.resetPickupTime }
                changedDriver={ props.changedDriver }
                initialDriverID={ props.initialDriverID }
                poDriverID={ props.order.id_driver }
                allowedToChangeTruckingCompany={ props.order.allowed_ops.update_dispatch_driver_details }
              />

            </div>
                        
              <div className={ style.vInput }>
                <DriverTruckInput
                  pickupOrder={ props.order }
                  handleChange={ props.changeDriverDetails }
                  handleClick={ props.handleClick }
                  maskOn={ props.maskOn }
                />
              </div>
              
              <div className={ style.updateBtn }>
                 <Button className={ props.classes.button } onClick={ props.submitPickupOrder } color="primary" variant="contained" >Update</Button>
              </div>
             
            <div className={style.notifyAndBtnWrapper}>

              {props.type !== 'go' && (
                <NotifyTruckingCompanyContainer
                  pickupOrder={ props.order }
                  notifyWho={ 'driver' }
                  direct={ true }
                  selectedDriverID={ props.showDetails ? props.selectedDriverID : props.order.id_driver || undefined }
                />
              )}

              <OrderButtonsContainer
                order={ props.order }
              />

            </div>

          </div>
        }

      </div>

    </Fragment>
   
  )
}

export default withStyles(styles)(commonOrderTruckingInfoWrapper);